// Размер текста клиентского портала (настройка профиля, per-device как тема):
//   normal - как всегда (корневой шрифт 16px)
//   large  - 112.5% (18px)
//   xlarge - 125% (20px)
// Все токены --text-* и большинство размеров заданы в rem, поэтому атрибут
// data-text-size на <html> (CSS в style.css меняет font-size корня) увеличивает
// текст везде без правки макетов. Шрифты графиков Chart.js заданы в px, их
// масштабирует getTextScale() в utils/chartConfig.js.

const STORAGE_KEY = 'textSize'
const DEFAULT_SIZE = 'normal'
export const TEXT_SIZES = ['normal', 'large', 'xlarge']
// Множитель для размеров в px (графики), синхронно с CSS-правилами html[data-text-size]
const SCALE = { normal: 1, large: 1.125, xlarge: 1.25 }

const listeners = new Set()

function getStoredSize() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return TEXT_SIZES.includes(raw) ? raw : DEFAULT_SIZE
  } catch {
    return DEFAULT_SIZE
  }
}

// Текущий выбор пользователя (normal|large|xlarge).
export function getTextSize() {
  return getStoredSize()
}

// Множитель текущего размера для px-значений (1 / 1.125 / 1.25).
export function getTextScale() {
  return SCALE[getStoredSize()] || 1
}

// Применяет размер к документу. Без сохранения - это делает setTextSize.
export function applyTextSize(size = getStoredSize()) {
  if (typeof document !== 'undefined') {
    if (size === DEFAULT_SIZE) {
      document.documentElement.removeAttribute('data-text-size')
    } else {
      document.documentElement.setAttribute('data-text-size', size)
    }
  }
  notify(size)
  // Живые графики перечитывают шрифты сами: chartConfig подписан через subscribe().
  // Импорт отсюда тянул бы chart.js на экран входа.
}

// Меняет размер: сохраняет в localStorage и применяет.
export function setTextSize(size) {
  if (!TEXT_SIZES.includes(size)) {
    throw new Error(`Invalid text size: ${size}`)
  }
  localStorage.setItem(STORAGE_KEY, size)
  applyTextSize(size)
}

// Подписка на смену размера - для компонентов с px-размерами (Leaflet-попапы и т.п.).
export function subscribe(callback) {
  listeners.add(callback)
  return () => listeners.delete(callback)
}

function notify(size) {
  listeners.forEach((cb) => {
    try {
      cb(size)
    } catch (e) {
      console.error('[textSizeService] listener error:', e)
    }
  })
}

// Инициализация - один раз на старте приложения.
// Inline-скрипт в index.html уже выставил data-text-size до загрузки CSS.
export function initTextSize() {
  applyTextSize()
}
